import { AttachmentHistoryTable } from "./AttachmentHistoryTable";

export default AttachmentHistoryTable;
